export const CARD_ART_HEIGHT = 300;
